<template>
  <v-menu offset-y left content-class="location-switch-menu">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="selectedLocation"
        class="location-switch-button"
        v-model="status"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="location-switch-button__pin"
          >mdi-map-marker-outline</v-icon
        >
        <span>{{ selectedLocation.name }}</span>
        <v-icon small>
          {{
            attrs["aria-expanded"] === "true"
              ? "mdi-chevron-up"
              : "mdi-chevron-down"
          }}
        </v-icon>
      </v-btn>
     
    </template>
    <v-list class="location-switch-list">
      <div class="location-switch-heading">
        <strong>Switch location</strong>
        <small>Select a workplace to manage</small>
      </div>
      <v-list-item
        class="location-switch-item"
        @click="selectLocation(item)"
        v-for="(item, index) in recentLocation"
        :key="index"
      >
        <v-list-item-icon>
          <v-icon>mdi-map-marker-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="selectedLocation.id === item.id">
          <v-icon color="success">mdi-check-circle</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import authService from "@/modules/Authentication/service.js";
import { mapActions } from 'vuex';

export default {
  name: "lcoation-change",
  props: ["location"],
  data: (vm) => ({
    status:false,
    recentLocation: [],
    selectedLocation: vm.location,
    locationCode: null,
    deviceCode: null,
    deviceName: null,
  }),
  created() {
    this.recentLocation = JSON.parse(
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
      )
    );
    if (!this.recentLocation) this.recentLocation = [];
    // console.log(
    //   "recentLocationrecentLocationrecentLocation",
    //   this.recentLocation
    // );
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    btnIcon(obj) {
      let value = 'mdi-chevron-right'
      if (obj['aria-expanded']) {
        console.log('in true')
        value = 'mdi-chevron-down'
      } else {
        console.log('in false')
        value = 'mdi-chevron-right'
      }
      console.log('tesetet', obj, value)
      return value
    },
    async selectLocation(location) {
      // console.log("location", location);
      if (location.pin) {
        await this.checkLocationCode(location);
        await this.login(location);
      } else {
        this.$toast.error("Authentication Needed", { timeout: 3000 });
        this.$router.push({ path: "/location" });
      }
    },
    checkLocationCode(location) {
      authService
        .getLocation(location.code)
        .then((response) => {
          this.selectedLocation = response.data;
          // this.setRecentLocation(this.location);
          localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}location`,
            JSON.stringify(this.selectedLocation)
          );

          localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}code`,
            location.code
          );
        })
        .catch((error) => {
          if (error) {
            switch (error.status) {
              case 404:
                this.$swal("Location", "Code Not Found", "error");
                break;
              default:
              // do nothing
            }
          }
        });
    },
    login(location) {
      const { deviceName, deviceCode } = authService.getStoredDevice();
      const loginInfo = {
        id: location.employeeId,
        pin: location.pin,
        locationCode: location.code,
        deviceCode: deviceCode,
        deviceName: deviceName,
      };
      authService
        .authenticate(loginInfo)
        .then(async (response) => {
          console.log('switch location response', response)
          // this.loading = false;
          await localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}Hometoken`,
            this.generateTimeClockToken()
          );

          this.$emit("submit");
          authService.setLastEmployeeId(response.data.employee.id);
          this.setEmployee(response.data.employee);
          // this.setRecentLocation();
          // await this.updateEmployee();
          // await this.$router.push({ name: "home" });
        })
        .catch((error) => {
          console.log('error on login', error)
          // this.loading = false;
          // this.$Progress.fail();
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
          this.$router.push({ name: "authentication-find-location" });
        });
    },
    generateTimeClockToken() {
      let rand = function () {
        return Math.random().toString(36).substr(2);
      };

      return rand() + rand();
    },
  },
};
</script>

<style scoped>
.location-switch-button {
  width: 100%;
  min-width: 0 !important;
  height: 42px !important;
  padding: 0 11px !important;
  border: 1px solid rgba(96, 165, 250, 0.25);
  border-radius: 12px;
  background: rgba(96, 165, 250, 0.09) !important;
  box-shadow: none !important;
  color: #bfdbfe !important;
  text-transform: none;
}

.location-switch-button span {
  min-width: 0;
  overflow: hidden;
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .location-switch-button {
    height: 40px !important;
    padding: 0 8px !important;
  }

  .location-switch-button span {
    font-size: 11px;
  }

  .location-switch-button__pin {
    margin-right: 5px;
  }
}

.location-switch-button__pin {
  margin-right: 7px;
  color: #60a5fa !important;
}

.theme--light .location-switch-button {
  border-color: #bfd1e8;
  background: #edf5ff !important;
  color: #27486f !important;
}

.theme--light .location-switch-button__pin {
  color: #2563eb !important;
}

.theme--light .location-switch-button .v-icon {
  color: #52749d !important;
}

.location-switch-heading {
  padding: 12px 15px 10px;
}

.location-switch-heading strong,
.location-switch-heading small {
  display: block;
}

.location-switch-heading small {
  margin-top: 2px;
  opacity: 0.62;
  font-size: 10px;
}

.location-switch-list {
  min-width: 270px;
}

.location-switch-item {
  min-height: 56px;
  margin: 3px 7px;
  border-radius: 10px;
}
</style>

<style>
.location-switch-menu {
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 14px !important;
  box-shadow: 0 22px 54px rgba(0, 0, 0, 0.34) !important;
}
</style>
